export function eventKeywordsSwiper() {
    const swiperContainer = document.querySelector('.event-keywords__ticker.swiper');
    
    if (!swiperContainer || typeof Swiper === 'undefined') {
        return;
    }

    const normalSpeed = 5000;
    const slowSpeed = 15000;

    const swiper = new Swiper(swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        loopedSlides: 14,
        speed: normalSpeed,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: false,
        },
        allowTouchMove: false,
        grabCursor: false,
        freeMode: {
            enabled: true,
            momentum: false,
        },
        watchSlidesProgress: true,
    });

    // Force continuous autoplay
    swiper.autoplay.start();

    // Slowdown on hover
    // swiperContainer.addEventListener('mouseenter', () => {
    //     swiper.params.speed = slowSpeed;
    //     console.log('mouse enter');
    // });

    // swiperContainer.addEventListener('mouseleave', () => {
    //     swiper.params.speed = normalSpeed;
    //     console.log('mouse leave');
    // });
}

